import { S as l } from "../../chunks/Section.SS-Irndy.js";
import { a as v } from "../../chunks/Section.SS-Irndy.js";
import { jsx as e } from "react/jsx-runtime";
import { Placeholder as c } from "@sitecore-jss/sitecore-jss-nextjs";
const y = ({ rendering: t, params: o }) => /* @__PURE__ */ e(
  l,
  {
    dataTestId: t == null ? void 0 : t.componentName,
    variant: (o == null ? void 0 : o.backgroundStyle) || "gray",
    overlay: o == null ? void 0 : o.allowOverlay,
    borderToggle: o == null ? void 0 : o.borderToggle,
    children: /* @__PURE__ */ e(c, { name: "section", rendering: t, params: o })
  }
);
export {
  l as Section,
  y as SectionBlock,
  v as SectionTitle
};
